// extracted by mini-css-extract-plugin
export var hasHeading__above = "ShareLinks-module--hasHeading__above--f6aba";
export var hasHeading__inline = "ShareLinks-module--hasHeading__inline--731a8";
export var heading = "ShareLinks-module--heading--f8a9c";
export var heading__above = "ShareLinks-module--heading__above--6d2a4";
export var heading__inline = "ShareLinks-module--heading__inline--0bc69";
export var item = "ShareLinks-module--item--fb72d";
export var items = "ShareLinks-module--items--b78d4";
export var leftAligned = "ShareLinks-module--leftAligned--f3236";
export var lgBreak = "1200";
export var mdBreak = "992";
export var padding = "ShareLinks-module--padding--4f7c2";
export var screenReaderText = "ShareLinks-module--screen-reader-text--00a3a";
export var shareLinks = "ShareLinks-module--shareLinks--a7502";
export var smBreak = "768";
export var xsBreak = "480";